import Button from '@/components/Button/Button';
import { ButtonVariants } from '@/components/Button/Button.types';
import styles from './ModalStores.module.css';
import Modal from '@/components/Modal/Modal';
import { Avatar, Box, Chip, Grid, Typography } from '@mui/material';
import { AlertTriangle } from 'react-feather';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export interface IAppProps {
  stores: string[] | undefined;
  groupName: string;
  isOpen: boolean;
  onClose: () => void;
}

const ModalStores = (props: IAppProps) => {
  const { t } = useTranslation();
  const { isOpen, onClose, stores, groupName } = props;
  return (
    <Modal
      className={styles.modal}
      isOpen={isOpen}
      onClose={() => onClose()}
      bodyClass={styles.modalBodyOver}
      showTitleDivider
      headerContent={`${groupName}  (${stores?.length} Stores)`}
      bodyContent={
        <Box p={3}>
          <div className={styles.body}>
            {stores?.map((storeNumber, idx) =>
              stores?.length === 1 || idx === stores.length - 1 ? `${storeNumber}` : `${storeNumber}, `,
            )}
          </div>
        </Box>
      }
      footerContent={
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          spacing={2}
          borderRadius={20}
          borderColor="red"
        >
          <Grid item>
            <Typography component="p" fontSize="1.8rem" color="rgb(95,95,95)">
              {t('promotions.deactivateModal.updateInfoMessage')}
              <Link to="/account/stores" style={{ textDecoration: 'none' }}>
                <Typography
                  component="span"
                  fontSize="1.7rem"
                  fontWeight="600"
                  color="var(--blue-700)"
                  px={0.6}
                  sx={{ textDecoration: 'auto' }}
                >
                  {t('nav.accountStores')}
                </Typography>
              </Link>
            </Typography>
          </Grid>

          <Grid item>
            <div className={styles.buttons}>
              <Button
                style={{ width: '12.5em', display: 'flex', justifyContent: 'center' }}
                variant={ButtonVariants.Primary}
                onClick={() => onClose()}
                type="button"
              >
                Close
              </Button>
            </div>
          </Grid>
        </Grid>
      }
    />
  );
};
export default ModalStores;
